import { render, staticRenderFns } from "./EditarForm.vue?vue&type=template&id=2984ca1f&scoped=true&"
import script from "./EditarForm.vue?vue&type=script&lang=ts&"
export * from "./EditarForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditarForm.vue?vue&type=style&index=0&id=2984ca1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984ca1f",
  null
  
)

export default component.exports